class Userlocation {
  constructor() {
    this.location = null;
    this.betslip = false;
    this.topEvents = false;
    this.sliderEvents = false;
    this.casinoShutdown = false;
    this.sportsbookShutdown = false;
    this.totalShutdown = false;
  }

  set updateLocation(location) {
    this.location = location;
  }

  set topEventSlider(data) {
    this.sliderEvents = data;
  }

  set updateBetslip(status) {
    this.betslip = status;
  }

  set updateTopEvents(status) {
    this.topEvents = status;
  }

  set updateAppStatus(status) {
    this.casinoShutdown = status?.casinoShutdown;
    this.sportsbookShutdown = status?.sportsbookShutdown;
    this.totalShutdown = status?.totalShutdown;
  }

  get getStatus() {
    return {
      location: this.location,
      betslip: this.betslip,
      topEvents: this.topEvents,
      sliderEvents: this.sliderEvents
    };
  }
}

const UserLocation = new Userlocation();
export default UserLocation;
